// A string, not a union: the wire enum carries Relay's `%future added value`.
export type LessonKindName = string;

export type ChecklistLesson = {
  id: string;
  kind: LessonKindName;
  part?: string | null | undefined;
  playsToday: number;
  completedToday: boolean;
};

export type ChecklistRow = {
  lessonId: string;
  kind: LessonKindName;
  part?: string | null | undefined;
  done: boolean;
  playsToday: number;
};

// Mirrors `LessonKind::order` in tutor-core (lesson library PRD §3). Kept as
// a table here rather than fetched: the server sends the lessons, and the
// course's method is the client's to lay out.
const ORDER: Record<string, number> = {
  ARTICLE: 1,
  VOCABULARY: 2,
  MINI_STORY: 3,
  POV: 4,
  AUDIO_ARTICLE: 5,
  COMMENTARY: 6,
};

/**
 * Today's list in the course's order, a story in parts as A, B, C. `done`
 * is the server's "heard to the end on `localDay`" (the lessons were fetched
 * with it); `playsToday` is every start, so the mini-story row can say how
 * many times it was heard (§4.2).
 */
export function todayChecklist(lessons: readonly ChecklistLesson[], _localDay: string): ChecklistRow[] {
  return [...lessons]
    .sort((a, b) => (ORDER[a.kind] ?? 99) - (ORDER[b.kind] ?? 99) || (a.part ?? '').localeCompare(b.part ?? ''))
    .map((l) => ({
      lessonId: l.id,
      kind: l.kind,
      part: l.part ?? null,
      done: l.completedToday,
      playsToday: l.playsToday,
    }));
}

/** After day 7 the card offers the next set; it never moves on by itself (PRD §4.2). */
export function shouldOfferNextSet(day: number | null): boolean {
  return day !== null && day > 7;
}
